/**
 * ExportDropdown - Dropdown per export Excel e PDF
 */
import React, { useState, useRef, useEffect } from 'react';
import { Download, FileSpreadsheet, FileText, ChevronDown } from 'lucide-react';
import styles from './ExportDropdown.module.css';

export type ExportFormat = 'excel' | 'pdf';

interface ExportDropdownProps {
  onExport: (format: ExportFormat) => void;
  disabled?: boolean;
  loading?: boolean;
}

export const ExportDropdown: React.FC<ExportDropdownProps> = ({
  onExport,
  disabled = false,
  loading = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Chiudi dropdown al click esterno
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleExport = (format: ExportFormat) => {
    setIsOpen(false);
    onExport(format);
  };

  return (
    <div className={styles.container} ref={dropdownRef}>
      <button
        className={styles.button}
        onClick={() => setIsOpen(!isOpen)}
        disabled={disabled || loading}
        type="button"
      >
        {loading ? (
          <span className={styles.spinner} />
        ) : (
          <Download size={18} />
        )}
        <span className={styles.btnLabel}>Esporta</span>
        <ChevronDown size={14} className={isOpen ? styles.chevronOpen : ''} />
      </button>

      {isOpen && (
        <div className={styles.dropdown}>
          <button
            className={styles.option}
            onClick={() => handleExport('excel')}
            type="button"
          >
            <FileSpreadsheet size={16} className={styles.iconExcel} />
            <span>Excel (.xlsx)</span>
          </button>
          <button
            className={styles.option}
            onClick={() => handleExport('pdf')}
            type="button"
          >
            <FileText size={16} className={styles.iconPdf} />
            <span>PDF (.pdf)</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default ExportDropdown;
